import CompanyDocumentEditComponent from "../components/CompanyDocumentEdit";
import useCompanyDocument from "../hooks/useCompanyDocument";

const CompanyDocumentEdit = (props) => {
  const useCompanyDocumentProps = useCompanyDocument(props);
  return <CompanyDocumentEditComponent {...useCompanyDocumentProps} />;
};

export default CompanyDocumentEdit;
